namespace GeniuzPOS.Product {
    export interface CsColorRow {
        Id?: number;
        ColorId?: string;
        ColorName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsColorRow {
        export const idProperty = 'ColorId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsColor';
        export const lookupKey = 'Product.CsColor';

        export function getLookup(): Q.Lookup<CsColorRow> {
            return Q.getLookup<CsColorRow>('Product.CsColor');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:สี:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:สี:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:สี:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:สี:Modify';

        export declare const enum Fields {
            Id = "Id",
            ColorId = "ColorId",
            ColorName = "ColorName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
